import { getResolvedDeliveryCountry } from "@src/template/state/modules/welcomeMessage/getResolvedDeliveryCountry";

export const getDeliveryCountry = async ({ geoCountry, minorCountries }) => {
  const deliveryCountry = minorCountries[geoCountry] || geoCountry;

  try {
    const resolvedDeliveryCountry = await getResolvedDeliveryCountry({
      geoCountry: deliveryCountry,
      minorCountries
    });

    return resolvedDeliveryCountry || null;
  } catch (_) {
    return null;
  }
};
